/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Damaged_PdfInputs */



/**
* | output |
* | --- |
* | "This PDF could not be read — it appears to be damaged or incomplete." |
*
* @param {Embedding_Error_Damaged_PdfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_damaged_pdf = /** @type {((inputs?: Embedding_Error_Damaged_PdfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Damaged_PdfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses PDF konnte nicht gelesen werden – es scheint beschädigt oder unvollständig zu sein.")
	return /** @type {LocalizedString} */ ("This PDF could not be read — it appears to be damaged or incomplete.")
});